import { useEffect } from 'react'
import { useDebounce } from './useDebounce'
import { DEBOUNCE_DELAY } from 'localConstants'

export const useDebouncedEffect = (effect: React.EffectCallback, deps?: React.DependencyList, delay: number = DEBOUNCE_DELAY) =>
  useEffect(useDebounce(effect, delay), deps)
